import type { ErrorType } from "@/components/api-error";

/**
 * Parses an API error into a consistent format.
 * @param error - The error object from TanStack Query or Axios.
 */
export type ApiError = {
  statusCode: number;
  message: string;
  success: boolean;
  errors: any[];
  errorType?: string;
};

export function parseApiError(error: unknown): {
  message: string;
  errorType?: ErrorType;
} {
  if (
    typeof error === "object"
    && error !== null
    && "message" in error
  ) {
    const err = error as { message: string; errorType?: ErrorType };
    return {
      message: err.message,
      errorType: err.errorType,
    };
  }

  return {
    message: "An unexpected error occurred",
    errorType: "GENERIC_ERROR",
  };
}
